import { Link } from "react-router-dom";
import Seo from "../../components/Seo";
import "./About.css";

const DIFFERENTIATORS = [
  {
    title: "Multi-organization by design",
    description:
      "Care is built for owners running more than one location. Branches stay organized under a single organization, with room to grow.",
  },
  {
    title: "Roles that match how teams work",
    description:
      "Organization owners, admins, managers, receptionists, and staff each see exactly what their job requires — and nothing they shouldn't touch.",
  },
  {
    title: "Appointments with built-in online booking",
    description:
      "Every organization gets a public site where clients can book directly. Your team manages everything from one calendar.",
  },
  {
    title: "Follow-ups and messaging that scale with your plan",
    description:
      "Client follow-ups and messaging are part of the product, sized to the subscription plan you choose.",
  },
  {
    title: "A public presence for every organization",
    description:
      "Each organization gets its own site with services, media, testimonials, and a contact channel — inquiries land in your inbox, not your personal phone.",
  },
];

const About = () => (
  <div className="about">
    <Seo
      title="About Carely IT"
      description="Carely IT helps organizations spend less time on operations — and more on the people they serve. Branches, teams, clients and appointments in one place."
      canonicalPath="/about"
    />
    <header className="about__hero">
      <p className="about__eyebrow">About Carely IT</p>
      <h1 className="about__title">
        We help organizations spend less time on operations — and more on the
        people they serve.
      </h1>
      <p className="about__lead">
        Care started from a simple observation: service organizations juggle
        too many disconnected tools to run a normal day. We put the whole day
        in one place.
      </p>
    </header>

    <section className="about__section">
      <div className="about__section-inner">
        <h2 className="about__heading">Our mission</h2>
        <p className="about__text">
          To simplify day-to-day operations for organizations of every size —
          so running branches, teams, clients, and appointments feels calm
          instead of chaotic. Software should carry the administrative weight,
          not add to it.
        </p>
      </div>
    </section>

    <section className="about__section about__section--tint">
      <div className="about__section-inner">
        <h2 className="about__heading">Who it's for</h2>
        <p className="about__text">
          Care is for organization owners and their teams — people who run one
          or more branches and want a single, dependable system for staff
          access, client records, appointments, and communication. If you're
          evaluating Care for your organization, call{" "}
          <a className="about__link" href="tel:01916707697">
            01916707697
          </a>{" "}
          or email{" "}
          <a className="about__link" href="mailto:zonayed@carelyit.com">
            zonayed@carelyit.com
          </a>{" "}
          and we'll walk you through it.
        </p>
      </div>
    </section>

    <section className="about__section">
      <div className="about__section-inner">
        <h2 className="about__heading">What makes Care different</h2>
        <ul className="about__differentiators">
          {DIFFERENTIATORS.map((item) => (
            <li key={item.title} className="about__differentiator">
              <h3 className="about__differentiator-title">{item.title}</h3>
              <p className="about__differentiator-text">{item.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className="about__cta">
      <h2 className="about__cta-title">See what Care costs</h2>
      <p className="about__cta-text">
        Plans are activated after onboarding — no self-serve registration.
      </p>
      <div className="about__cta-actions">
        <Link to="/pricing" className="about__cta-btn about__cta-btn--primary">
          View pricing
        </Link>
        <Link to="/login" className="about__cta-btn about__cta-btn--secondary">
          Login
        </Link>
      </div>
    </section>
  </div>
);

export default About;
